export class ZApiService {
    constructor() {
        this.AJAX_OPTIONS = {
            contentType: "application/json; charset=utf-8",
            dataType: "json",
            accepts: {
                text: "application/json"
            }
        };
    }
    get(url) {
        return this.api_ajax(url);
    }
    put(url, data) {
        return this.api_ajax(url, data, 'PUT');
    }
    post(url, data) {
        return this.api_ajax(url, data, 'POST');
    }
    del(url) {
        return this.api_ajax(url, undefined, 'DELETE');
    }
    api_ajax(url, data, type = 'GET') {
        return new Promise((resolve, reject) => {
            $.ajax(Object.assign({}, this.AJAX_OPTIONS, { type, url, data: JSON.stringify(data) }))
                .done((data) => {
                if (data.err) {
                    console.error(data.err);
                    modalService.error(data.err);
                    return reject(data.err);
                }
                resolve(data);
            }).fail((res) => {
                const err = new Error(`${res.statusText}, status = ${res.status}`);
                console.error(err);
                modalService.error(err);
                return reject(err);
            });
        });
    }
}
//# sourceMappingURL=api_service.js.map